<button
	[attr.inert]="!showMenu() && showExpand() ? null : ''"
	(click)="expandAll.emit()"
	aria-label="Expand all groups"
	mat-button
>
	<mat-icon>unfold_more</mat-icon>
	<span>Expand All Groups</span>
</button>

<button
	[attr.inert]="!showMenu() && showCollapse() ? null : ''"
	(click)="collapseAll.emit()"
	aria-label="Collapse all groups"
	mat-button
>
	<mat-icon>unfold_less</mat-icon>
	<span>Collapse All Groups</span>
</button>

<button
	[attr.inert]="showMenu() ? null : ''"
	[matMenuTriggerFor]="groupsMenu"
	aria-label="Open group expand/collapse menu"
	mat-button
>
	<mat-icon>unfold_more</mat-icon>
	<span>Expand/Collapse</span>
</button>

<mat-menu #groupsMenu="matMenu" class="custom-mat-panel">
	<button (click)="expandAll.emit()" mat-menu-item>
		<mat-icon>unfold_more</mat-icon>
		<span>Expand All Groups</span>
	</button>
	<button (click)="collapseAll.emit()" mat-menu-item>
		<mat-icon>unfold_less</mat-icon>
		<span>Collapse All Groups</span>
	</button>
</mat-menu>
